import { createActions } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions({
    // view brand
    requestViewBrand: ['id'],
    viewBrandSucceeded: ['data'],
    viewBrandFailed: ['error'],

    // clear state
    clearBrandViewState: null,
});

export default {
    // view brand
    [types.REQUEST_VIEW_BRAND]: (state) => ({
        ...state,
        view: {
            ...state.view,
            loading: true,
            error: null,
        },
    }),
    [types.VIEW_BRAND_SUCCEEDED]: (state, { data }) => ({
        ...state,
        view: {
            ...state.view,
            brandDetails: data,
            loading: false,
        },
    }),
    [types.VIEW_BRAND_FAILED]: (state, { error }) => ({
        ...state,
        view: {
            ...state.view,
            loading: false,
            error,
        },
    }),

    // clear state
    [types.CLEAR_BRAND_VIEW_STATE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            brandDetails: null,
        },
    }),
}
